import React, { useState } from 'react';
import { useDialog } from 'dialog-provider-hooks';
import actions from 'roles-actions-permissions/actions';
import { useHistory, useLocation } from 'react-router';
import usePermissions from 'hooks/permissions-hooks';
import { filterTypes } from '../../basic/AdvancedFilters';
import AppTable from '../../basic/AppTable';
import AppLoader from '../../basic/AppLoader';
import { useItems } from '../../../hooks/atoms/items-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';

const QuestionnairesTable = () => {
  const [ filterQuery, setFilterQuery ] = useState({});
  const { hasPermissions } = usePermissions();

  const {
    items: questionnaires,
    itemsLoading: questionnairesLoading,
    pagination,
    deleteItem,
  } = useItems(CollectionKeys.QUESTIONNAIRES, { filterQuery });

  const { openDialog } = useDialog();

  const openDeleteQuestionnairesDialog = (id) => {
    openDialog({
      title: 'Delete Questionnaire?',
      body() {
        return (<p>Are you sure you want to delete the Questionnaire?</p>);
      },
      onSubmit() {
        deleteItem(id);
      },
    });
  };

  const handleDelAction = (event, id) => {
    openDeleteQuestionnairesDialog(id);
    return id;
  };

  const location = useLocation();
  const history = useHistory();

  if (questionnairesLoading) {
    return <AppLoader />;
  }

  const tableColumns = [
    { id: 1, label: 'ID', field: 'id' },
    { id: 2, label: 'Name', field: 'name' },
    { id: 3, label: 'Description', field: 'description' },
  ];

  const handleViewAction = (e, id) => {
    history.push({
      pathname: location.pathname,
      search: `?id=${ id }`,
    });
  };

  return (
    <>
      <AppTable
        columns={ tableColumns }
        data={ questionnaires }
        loading={ questionnairesLoading }
        paginationProps={ pagination }
        advancedFiltersProps={ {
          properties: [
            {
              value: 'id',
              label: 'ID',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'name',
              label: 'Name',
              type: filterTypes.FREE_TEXT,
            },
            {
              value: 'description',
              label: 'Description',
              type: filterTypes.FREE_TEXT,
            },
          ],
          initialAndFilterOptions: [],
          onQueryChange: setFilterQuery,
        } }
        ViewProp={ { handleView: handleViewAction } }
        DelProp={ { handleDelete: handleDelAction, disabledDelete: !hasPermissions(actions.DELETE_QUESTIONNAIRE) } }
      />
    </>
  );
};

export default QuestionnairesTable;

